import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export interface ChapterSaveProgress {
  completed: number;
  total: number;
  label: string;
}

export function ChapterSaveProgressDialog({ progress }: { progress: ChapterSaveProgress | null }) {
  const { t } = useTranslation();
  if (!progress) return null;
  const percentage = progress.total ? Math.round((progress.completed / progress.total) * 100) : 0;

  return (
    <Dialog open disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>{t('chapters.publish.saving_title')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <LinearProgress variant="determinate" value={percentage} />
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">{progress.label}</Typography>
            <Typography variant="body2" fontWeight={700}>{percentage}%</Typography>
          </Stack>
          <Typography variant="caption" color="text.secondary">
            {t('chapters.publish.saving_step', { current: Math.min(progress.completed + 1, progress.total), total: progress.total })}
          </Typography>
          {progress.completed === progress.total && (
            <Stack direction="row" spacing={1} alignItems="center" color="success.main">
              <CheckCircleOutline fontSize="small" />
              <Typography variant="body2">{t('chapters.publish.saving_complete')}</Typography>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
